import { get, post } from '@/plugins/axios'
import axios from 'axios'
import store from '@/store'
/**
* 查询平台订单详情列表
* @param {Object} params
*/
export const getSign = () => {
  return post('/customer/oss/sign?path=client/')
  // return post('/customer/oss/sign/another?bucketName=theckbstest&path=client/')
}
interface GSNA {
  bucketName: string // bucket名称
  path: string // 文件路径 根据模块功能命名
  type: number // 是否覆盖文件
}
export const getSignNewApi = ({ bucketName, path, type }:GSNA) => {
  return post(`/customer/oss/sign/another?bucketName=${bucketName}&path=${path}&type=${type}`)
}
/**
 * 获取client_id
 *
 * @param {*} params
 */
export const getClientIdApi = () => {
  return get('/crm/paypal/client/id')
}

// 上传文件
export const uploadFileApi = (data: any) => {
  // console.log(data)
  // const formData:any = new FormData()
  // formData.append('file', data.file)
  // formData.append('path', data.path)
  // return post('/customer/oss/putOSS', {data:formData}, {
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   }
  // })

  const token = store.getters.token
  return axios({
    url: process.env.VUE_APP_URL + '/customer/oss/putOSS',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-AuthToken': token
    }
  })
}
